export default {
    // SET CATEGORIES STORE GENERAL
    /*obtengo todos las categories*/
    SET_CATEGORIES: function(state, categories) {
        state.categories = categories;
    },

    SET_CAT: function(state, cat_data) {
        state.selected_category = cat_data;
    }
};